export class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

export function extractErrorMessage(error) {
  if (error instanceof ApiError) {
    return error.message;
  }
  
  if (error.response?.data) {
    const data = error.response.data;
    
    if (typeof data.detail === 'string') {
      return data.detail;
    }
    
    if (Array.isArray(data.detail)) {
      return data.detail.map(err => err.msg || JSON.stringify(err)).join(', ');
    }
    
    if (typeof data === 'string') {
      return data;
    }
    
    if (data.message) {
      return data.message;
    }
  }
  
  if (error.message) {
    return error.message;
  }
  
  return '请求失败，请稍后重试';
}

export function handleApiError(error, defaultMessage = '操作失败') {
  const message = extractErrorMessage(error);
  throw new ApiError(message, error.response?.status, error.response?.data);
}

export function cleanParams(params) {
  const cleanParams = {};
  Object.keys(params).forEach(key => {
    if (params[key] !== '' && params[key] !== null && params[key] !== undefined) {
      cleanParams[key] = params[key];
    }
  });
  return cleanParams;
}

export function createApiHandler(apiCall, errorMessage = '操作失败') {
  return async (...args) => {
    try {
      const response = await apiCall(...args);
      return response.data;
    } catch (error) {
      handleApiError(error, errorMessage);
    }
  };
}
